import * as React from 'react'
import intl from 'react-intl-universal'
import { Placeholder, RedButton, WhiteButton, Wrapper } from './atoms'
import { getRegisterLink, LocaleClass } from '../../utils'
import { LOCALE } from '@foxrenderfarm/internals'

interface Props {
  locale: LOCALE
}

export const ContactBar = ({ locale }: Props) => {
  const contactLink = LocaleClass.isEqualLocale(locale, LOCALE.ES)
    ? 'mailto:quique@foxrenderfarm.com?subject=Fox Renderfarm Inquiry'
    : 'mailto:service@foxrenderfarm.com?subject=Fox Renderfarm Inquiry'

  return (
    <>
      <Placeholder />
      <Wrapper>
        <RedButton href={getRegisterLink(locale)}>{intl.get('index.header.register')}</RedButton>
        <WhiteButton href={contactLink}>{intl.get('index.contact.us')}</WhiteButton>
      </Wrapper>
    </>
  )
}
